import registerApiBack from "./apiBack";
import registerApiRoute from "./apiRoute";

export { registerApiBack, registerApiRoute };
